








































import {Component, Vue} from 'vue-property-decorator';
import {namespace} from 'vuex-class';
import CreateCompanyForm from '@/components/beta/Forms/CreateCompanyForm.vue';
import AddExhibitionForm from '@/components/beta/Forms/AddExhibitionForm.vue';
import EditProfileForm from '@/components/beta/Forms/EditProfileForm.vue';
import AddQuestionForm from '@/components/beta/Forms/AddQuestionForm.vue';
import AddAnswersForm from '@/components/beta/Forms/AddAnswersForm.vue';
import AddComentForm from '@/components/beta/Forms/AddComentForm.vue';
import AddSignatureForm from '@/components/beta/Forms/AddSignatureForm.vue';
import ChangeIncludeQuestionForm from '@/components/beta/Forms/ChangeIncludeQuestionForm.vue';
import ShowScanProducts from '@/components/beta/Forms/ShowScanProducts.vue';
import NoteEditForm from '@/components/beta/Forms/NoteEditForm.vue';
import ExportAllForm from '@/components/beta/Forms/ExportAllForm.vue';
import ExportOneForm from '@/components/beta/Forms/ExportOneForm.vue';
import ExportPersonal from '@/components/beta/Forms/ExportPersonal.vue';
import QuestionsForm from '@/components/beta/Forms/QuestionsForm.vue';
import NewNoteForm from '@/components/beta/Forms/NewNoteForm.vue';

const dialog = namespace('dialog')

@Component({
  name: "FullDialog",
  components: {
    NewNoteForm,
    CreateCompanyForm,
    AddExhibitionForm,
    EditProfileForm,
    AddQuestionForm,
    AddAnswersForm,
    AddComentForm,
    AddSignatureForm,
    ChangeIncludeQuestionForm,
    ShowScanProducts,
    NoteEditForm,
    ExportAllForm,
    ExportOneForm,
    ExportPersonal,
    QuestionsForm,
  }
})
export default class FullDialog extends Vue {
  @dialog.Getter('fullDialogShow') protected fullDialogShow: any
  @dialog.Getter('formDialog') protected formDialog: any
  @dialog.Getter('titleDialog') protected titleDialog: any
  @dialog.Getter('subtitleDialog') protected subtitleDialog: any
  @dialog.Mutation('SetFullDialogShow') protected SetFullDialogShow: any

  save(){
    alert('Save')
  }
}
